import type { ElementRef } from '@angular/core';
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';

import type { User } from '@core/account-types';
import type { Attachment } from '@core/attachments-types';
import { AttachmentItemComponent } from '@core/attachments-ui';
import { trackByProp } from '@core/common-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { DateComponent } from '@core/time-ui';
import {
  AvatarComponent,
  BoxComponent,
  ButtonComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-approval-request-message-box',
  templateUrl: './approval-request-message-box.component.html',
  styleUrls: ['./approval-request-message-box.component.less'],
  imports: [
    AttachmentItemComponent,
    AvatarComponent,
    BoxComponent,
    ButtonComponent,
    DateComponent,
    HeadingComponent,
    IconComponent,
    RtTooltip,
    TranslatePipe,
  ],
})
export class ApprovalRequestMessageBoxComponent {
  public readonly COLLAPSED_MESSAGE_MAX_HEIGHT = 72; // 3 * @line-height

  @Input() public requester: User | null;
  @Input() public attachments: Attachment[];
  @Input() public bodyHtml: string | null;
  @Input() public createdAt: string;

  public messageCollapsed: boolean = true;
  public hasExpandButton: boolean;

  public trackById = trackByProp<{ id: number }>({ prop: 'id' });

  @ViewChild('requestMessageText') private requestMessageText: ElementRef;

  constructor(
    private i18n: I18nService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngAfterViewInit(): void {
    if (this.bodyHtml) {
      this.hasExpandButton =
        this.requestMessageText.nativeElement.scrollHeight > this.COLLAPSED_MESSAGE_MAX_HEIGHT;
      this.cdRef.detectChanges();
    }
  }

  public get requesterFullName(): string {
    if (!this.requester) return this.i18n.translate('app.requisitions.flow.deleted_user');

    const { firstName, lastName } = this.requester;
    return `${firstName} ${lastName}`;
  }

  public toggleShowMore(): void {
    this.messageCollapsed = !this.messageCollapsed;
    this.cdRef.detectChanges();
  }
}
